import { get } from "@nhi/utils"

import { IArchive } from "../interfaces/mongodb/IArchive"

/**
 * Endpoint for archive based on Topic
 * @param path Related path
 * @param template Template type to filter result
 * @param take Number of articles to return
 * @param skip Number of articles to skip
 * @returns list of matching archive articles
 */

export async function getArchive(
    path: string | undefined,
    template: string | undefined,
    take = 20,
    skip = 0
) {
    if (!path) return null

    const endpoint =
        `${process.env.NEXT_PUBLIC_CONTENT_API}/Content/Archive?path=` +
        encodeURIComponent(path) +
        `${template ? `&template=${template}` : ""}` +
        `&take=${take}` +
        `&skip=${skip}`

    return await get<IArchive>(endpoint)
}
